module.exports = __webpack_public_path__ + "img/3.dd73dd61.png";